/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostEmployeesCheckMutationRequest, PostEmployeesCheckMutationResponse, PostEmployeesCheck400 } from "../entities/PostEmployeesCheck";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { postEmployeesCheck } from "../api/postEmployeesCheck";
import { useMutation } from "@tanstack/react-query";

export const postEmployeesCheckMutationKey = () => [{ url: '/employees/check' }] as const

export type PostEmployeesCheckMutationKey = ReturnType<typeof postEmployeesCheckMutationKey>

/**
 * @description Проверка номера сотрудника в Drivee
 * @summary Проверка номера сотрудника в Drivee
 * {@link /employees/check}
 */
export function usePostEmployeesCheck<TContext>(options: 
{
  mutation?: UseMutationOptions<PostEmployeesCheckMutationResponse, ResponseErrorConfig<PostEmployeesCheck400>, {data: PostEmployeesCheckMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostEmployeesCheckMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postEmployeesCheckMutationKey()

  return useMutation<PostEmployeesCheckMutationResponse, ResponseErrorConfig<PostEmployeesCheck400>, {data: PostEmployeesCheckMutationRequest}, TContext>({
    mutationFn: async({ data }) => {
      return postEmployeesCheck(data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}